import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton } from 'material-ui';
import { bindActionCreators } from 'redux';
import { Tab, Tabs } from 'material-ui';

import Tab1LoadEmployeePersonalDetails from './components/Tab1LoadEmployeePersonalDetails';
import Tab2LoadEmployeeContactDetails from './components/Tab2LoadEmployeeContactDetails';
import Tab3LoadEmployeeSalaryDetails from './components/Tab3LoadEmployeeSalaryDetails';
import Tab4LoadEmployeeOlQualification from './components/Tab4LoadEmployeeOlQualification';
import Tab5LoadEmployeeAlQulification from './components/Tab5LoadEmployeeAlQulification';
import Tab6LoadEmployeeHigherEducationDetails from './components/Tab6LoadEmployeeHigherEducationDetails';

const styles = theme => ({
    layoutRoot: {}
});

class ViewEmployee extends Component {

    state = {
        value: 0
    };

    searchEmployeePersanolDetails() {
        // alert();
    }

    handleChangeT = (event, value) => {

        this.setState({ value });
        event.preventDefault();
    };

    render() {
        const { classes, openEditContactDialog } = this.props;
        const { value } = this.state;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                // header={
                //     <div className="flex flex-1 flex-col sm:flex-row items-center justify-between p-24">

                //         <div className="flex flex-1 items-center">
                //             <Hidden lgUp>
                //                 <IconButton
                //                     aria-label="open left sidebar"
                //                 >
                //                     <Icon>menu</Icon>
                //                 </IconButton>
                //             </Hidden>

                //             <div className="flex items-center">
                //                 <Typography variant="title">All Employee Details</Typography>
                //             </div>
                //         </div>

                //         <div className="flex items-center">

                //             <Icon color="action">search</Icon>

                //             <TextField
                //                 placeholder="Search for anything"
                //                 className="pl-16"
                //                 id="empPersanol"
                //                 onChange={this.searchEmployeePersanolDetails}
                //                 fullWidth
                //                 inputProps={{
                //                     'aria-label': 'Search'
                //                 }}
                //             />
                //         </div>
                //     </div>
                // }
                contentToolbar={
                    <Tabs
                        value={value}
                        onChange={this.handleChangeT}
                        indicatorColor="primary"
                        textColor="primary"
                        scrollable
                        scrollButtons="auto"
                        classes={{
                            root: classes.tabsRoot
                        }}
                    >
                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="All Employee Personal Details"
                        />

                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="All Employee Contact Details"
                        />

                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="All Employee Salary Details"
                        />

                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="All Employee Ol Qulifications"
                        />

                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="All Employee al Qulifications"
                        />
                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Higher Education Qulifications"
                        />
                    </Tabs>
                }
                content={


                    <div className="px-24">


                        {value === 0 &&
                            (
                                // <div>dd</div>
                                <Tab1LoadEmployeePersonalDetails />

                            )}

                        {value === 1 && (
                            <Tab2LoadEmployeeContactDetails />
                        )}

                        {value === 2 && (
                            <Tab3LoadEmployeeSalaryDetails />
                        )}
                        {value === 3 && (
                            <Tab4LoadEmployeeOlQualification />
                        )}
                         {value === 4 && (
                            <Tab5LoadEmployeeAlQulification />
                        )}
                        {value === 5 && (
                            <Tab6LoadEmployeeHigherEducationDetails />
                        )}

                    </div>

                }
            />
        )
    }


}

export default withStyles(styles, { withTheme: true })(ViewEmployee);


// WEBPACK FOOTER //
// ./src/main/content/hr/viewEmployee/ViewEmployee.js